import { useGetOfficeDeadlineEventSenderQuery } from 'store/api/offices';

/**
 * The address a tenant without Azure email integration sends every deadline invite from, in place of an office's
 * own deadline event email address; undefined for a tenant that sends through its own mailbox. Until isKnown the
 * answer has not arrived, so whether an office's own address is kept is not known either.
 */
export const useFixedDeadlineEventSender = (): { fixedSender: string | undefined; isKnown: boolean } => {
    const { data, isSuccess } = useGetOfficeDeadlineEventSenderQuery();
    return { fixedSender: data?.address ?? undefined, isKnown: isSuccess };
};
